export const place_map_lang = {
  TH: {
    title: "แผนที่แสดงข้อมูลที่อยู่",
    customer_name: "ชื่อลูกค้า",
    customer_place: "สถานที่ลูกค้า",
    address: "สถานที่",
    place_id: "รหัสที่อยู่",
    location: "ตำแหน่ง",
    user_id: "รหัสพนักงาน",
    name: "ชื่อ",
    surename: "สกุล",
    login: "เข้าสู่ระบบล่าสุด",
    position: "ตำแหน่ง",
    table_title: "รายการพนักงาน",
    status: "สถานะ",
  },
  EN: {
    title: "Map Showing Customer Place",
    customer_name: "customer name",
    customer_place: "customer's place",
    address: "address",
    place_id: "place ID",
    location: "location",
    user_id: "user ID",
    name: "name",
    surename: "surename",
    login: "last login",
    position: "position",
    table_title: "User table",
    status: "status",
  }
}
